import { render } from "./SimpleRank3.vue?vue&type=template&id=e899e90c&scoped=true"
import script from "./SimpleRank3.vue?vue&type=script&lang=js"
export * from "./SimpleRank3.vue?vue&type=script&lang=js"

import "./SimpleRank3.vue?vue&type=style&index=0&id=e899e90c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e899e90c"],['__file',"src/components/h5/board/SimpleRank3.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e899e90c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e899e90c', __exports__)) {
    api.reload('e899e90c', __exports__)
  }
  
  module.hot.accept("./SimpleRank3.vue?vue&type=template&id=e899e90c&scoped=true", () => {
    api.rerender('e899e90c', render)
  })

}


export default __exports__